const TEMPLATE = `
<section class="news-feed-content-main fade-up">
    <div class="container-fluid">

        <!-- Секція новин з анімованим контейнером -->
        <div class="news-section-feed" id="news-section" data-section="news-section-1" data-animate-child
             data-delay="200">
            <!-- Сюди завантажуватимуться блоки новин з новим дизайном -->
        </div>

        <a class="load-more-" href="#">Завантажити більше</a>
    </div>
</section>
`;

class BmlNewsFeedList extends HTMLElement {
    connectedCallback() { if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE; }
}
customElements.define('bml-news-feed-list', BmlNewsFeedList);
